import React, { useState, useEffect } from 'react'
import Sidebar from '../Sidebar/Sidebar'
import Header from '../Header/Header'
import BottomNav from '../BottomNav/BottomNav'
import PanelNavigation from '../../WebView/Navigation/PanelNavigation/PanelNavigation'

function Panel() {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [showMobileSidebar, setShowMobileSidebar] = useState(false)
  const [hideSideBar, setHideSideBar] = useState(false)

  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768
      setIsMobile(mobile)

      // On mobile, always collapse sidebar and hide it initially
      if (mobile) {
        setIsCollapsed(true)
        setShowMobileSidebar(false)
      } else {
        setShowMobileSidebar(false)
      }
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  // Handle sidebar toggle
  const handleSidebarToggle = () => {
    if (isMobile) {
      setShowMobileSidebar(!showMobileSidebar)
    } else {
      setIsCollapsed(!isCollapsed)
    }
  }

  // Handle mobile sidebar close
  const handleMobileSidebarClose = () => {
    if (isMobile) {
      setShowMobileSidebar(false)
    }
  }

  return (
    <div className="flex h-screen bg-gray-50 relative">
      {/* Mobile Overlay */}
      {isMobile && showMobileSidebar && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={handleMobileSidebarClose}
        />
      )}

      {/* Sidebar Container - Hidden on mobile, use bottom nav instead */}
      {!hideSideBar && !isMobile && (
        <div className={`
          fixed left-0 top-0 h-full z-50
          transform transition-transform duration-300 ease-in-out
          ${isMobile ? (showMobileSidebar ? 'translate-x-0' : '-translate-x-full') : 'translate-x-0'}
        `}>
          <Sidebar
            setHideSideBar={setHideSideBar}
            isCollapsed={isMobile ? false : isCollapsed}
            onToggleCollapse={handleSidebarToggle}
            onMobileClose={handleMobileSidebarClose}
            isMobile={isMobile}
          />
        </div>
      )}

      {/* Main Content */}
      <div className={`
        flex-1 flex flex-col transition-all duration-300 ease-in-out w-full
        ${!isMobile && !hideSideBar ? (isCollapsed ? 'ml-20' : 'ml-64') : ''}
      `}>
        <Header
          onMenuClick={handleSidebarToggle}
          hideSideBar={hideSideBar}
          isCollapsed={isCollapsed}
          isMobile={isMobile}
          showMobileSidebar={showMobileSidebar}
        />
        <main className={`
          ${hideSideBar ? "p-4 md:p-6" : "p-4 md:p-6"}
          flex-1 overflow-y-auto
          ${isMobile ? 'pb-20' : ''}
        `}>
          <PanelNavigation />
        </main>
      </div>

      {/* Bottom Navigation - Only on mobile */}
      {isMobile && <BottomNav />}
    </div>
  )
}

export default Panel
